<template>
  <div class="sy-nav">
    <van-nav-bar class="title" :title="$route.meta.title" left-arrow fixed @click-left="onClickLeft" />
    <div class="content">
      <div class="logo" align="center">
        <img src="../../assets/logo-family.png">
      </div>
      <div class="big-text" align="center">
        <span>您的家人是否有盖德系统账号？</span>
      </div>
      <div class="small-text">
        <span>如果您的家人使用手机号注册过盖德健康应用系统，您可以 直接绑定手机账号。无论您身在何处，都能随时关注 、管理 家人健康。</span>
      </div>
      <div class="bind-btn" @click="goPage('/familyApp/bind')">
        <img src="../../assets/images/family/guider-bind-btn.png">
      </div>
      <div class="register-btn" @click="goPage('/family/add')">
        <img src="../../assets/images/family/register-family-btn.png">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    goPage: function(url) {
      this.$router.push(url)
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
        //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .sy-nav {
    height: 100vh;
    background: white;
  }
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .content {
    background-color: white;
    .logo{
      padding-top: 2.04rem;
      img{
        width: 91px;
        height: 91px;
      }
    }
    .big-text{
      padding-top: 35px;
      font-size:19px;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
      color:rgba(0,0,0,1);
    }
    .small-text{
      margin-top: 16px;
      padding: 0px 12px;
      font-size:13px;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
      color:rgba(125,125,125,1);
      line-height:19px;
    }
    .bind-btn{
      padding-top: 60px;
      img{
        padding: 0px 16px;
        width: 100%;
        height: 42px;
      }
    }
    .register-btn{
      padding-top: 20px;
      img{
        padding: 0px 16px;
        width: 100%;
        height: 42px;
      }
    }
  }
</style>

